import { TransceiverRawData, TransceiverRawDataRequest, TransceiversApi } from '@/api';
import { ApiUtils } from '@/common/ApiUtils';

export class TransceiverService {
	constructor(private transceiversApi: TransceiversApi = new TransceiversApi()) {}

	public async setDeploymentMeshMode(id: string | number): Promise<{ errorMessage?: string }> {
		if (typeof id === 'string') {
			id = parseInt(id, 10);
		}
		try {
			await this.transceiversApi.setMeshDeploymentMode(id);
			return {};
		} catch (e) {
			return ApiUtils.handleApiError(
				e,
				`An unknown error occurred setting transceiver mesh mode to deployment`,
			);
		}
	}

	public async getRawData(
		id: string | number,
		request: TransceiverRawDataRequest,
	): Promise<{ errorMessage?: string; rawData?: TransceiverRawData[] }> {
		if (typeof id === 'string') {
			id = parseInt(id, 10);
		}
		try {
			const response = await this.transceiversApi.getTransceiverRawDataFromIngest(id, request);
			return { rawData: response.data };
		} catch (e) {
			return ApiUtils.handleApiError(e, `Failed to fetch Transceiver raw data by id: ${id}`);
		}
	}
}
